import { createFileRoute } from '@tanstack/react-router'
import { ROUTES } from '@/constants/routeConstants'
import { AiUsagePage } from '@/pages/AiUsagePage'

const AiUsageRoute = () => {
  return <AiUsagePage />
}

export const Route = createFileRoute(ROUTES.AI_USAGE)({
  component: AiUsageRoute,
})
